/*
 * Saison-Aktionen (CompuHub, 01.10.2026) — was der Browser dazu tut:
 *
 * 1. Countdown: jedes [data-cm-aktion-countdown] zählt bis data-bis (Sekunden seit 1970). Liquid schreibt das Ende als
 *    Datum hinein; ohne JavaScript bleibt das stehen.
 * 2. Ablauf: Liquid rechnet, wenn Shopify die Seite baut. Kommt eine Seite aus dem Cache, wäre die Werbung nach „Bis“
 *    noch sichtbar — darum blendet dieses Skript jedes [data-cm-aktion-bis] aus, sobald das Ende erreicht ist (wie das
 *    „Neu!“-Schild in cm-neu-beratung.js).
 * 3. Leiste schließen: merkt sich die Sitzung je Aktion (sessionStorage).
 *
 * Keine Vorschau mehr von hier (02.10.2026, Sicherheits-Audit Punkt 10): die Vorschau steht als Feld „vorschau“ im
 * Shop-Metafeld und wird von snippets/cm-aktion-daten nur im unveröffentlichten Theme gerendert. Der frühere Weg —
 * ?cm_aktion_vorschau=<base64url> → Warenkorb-Attribut _cm_aktion_vorschau — ist weg; ein solcher Parameter wird
 * ignoriert, ein noch gesetztes Attribut liest niemand mehr.
 */
(() => {
  // Texte in der Sprache der Seite: window.cmT.aktion aus snippets/cm-x-js-texts (Texte in snippets/cm-xt-js, Abschnitt aktion). Fehlt cmT
  // oder ein Schlüssel, gilt der deutsche Text hier; {name} wird ersetzt.
  const cmTexts = (window.cmT && window.cmT.aktion) || {};
  const tx = (key, de, vars) => {
    const own = cmTexts[key];
    const text = typeof own === 'string' && own && !/^(translation missing|\[text fehlt)/i.test(own) ? own : de;
    return vars ? text.replace(/\{(\w+)\}/g, (all, name) => (name in vars ? vars[name] : all)) : text;
  };
  const now = () => Math.floor(Date.now() / 1000);
  const two = (n) => String(n).padStart(2, '0');

  function rest(sekunden) {
    const s = Math.max(0, sekunden);
    return { tage: Math.floor(s / 86400), std: Math.floor((s % 86400) / 3600), min: Math.floor((s % 3600) / 60), sek: s % 60 };
  }

  function text(r) {
    const uhr = `${two(r.std)}:${two(r.min)}:${two(r.sek)}`;
    if (r.tage > 1) return tx('days_other', '{days} Tage {time}', { days: r.tage, time: uhr });
    if (r.tage === 1) return tx('days_one', '1 Tag {time}', { time: uhr });
    return uhr;
  }

  function tick() {
    const t = now();
    for (const el of document.querySelectorAll('[data-cm-aktion-bis]:not([data-cm-aktion-abgelaufen])')) {
      const bis = Number(el.getAttribute('data-cm-aktion-bis'));
      if (Number.isFinite(bis) && bis > 0 && t >= bis && !el.hasAttribute('data-cm-aktion-vorschau')) el.setAttribute('data-cm-aktion-abgelaufen', '');
    }
    for (const el of document.querySelectorAll('[data-cm-aktion-countdown]')) {
      const bis = Number(el.getAttribute('data-bis'));
      if (!Number.isFinite(bis) || bis <= 0) continue;
      const r = rest(bis - t);
      if (el.getAttribute('data-form') === 'kacheln') {
        for (const [teil, wert] of Object.entries(r)) {
          const b = el.querySelector(`[data-teil="${teil}"]`);
          if (b) b.textContent = teil === 'tage' ? String(wert) : two(wert);
        }
      } else {
        const satz = el.getAttribute('data-satz');
        el.textContent = satz ? satz.replace('{countdown}', text(r)) : tx('left', 'Noch {countdown}', { countdown: text(r) });
      }
    }
  }

  function start() {
    tick();
    window.setInterval(tick, 1000);
    document.addEventListener('click', (e) => {
      const zu = e.target.closest && e.target.closest('[data-cm-aktion-zu]');
      if (zu) {
        const leiste = zu.closest('[data-cm-aktion]');
        if (leiste) {
          leiste.hidden = true;
          try { sessionStorage.setItem(`cm-aktion-zu-${leiste.getAttribute('data-cm-aktion')}`, '1'); } catch (_) {}
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
